<template>
    <div class="error-main">
        <router-view></router-view>
    </div>
</template>

<script>
    export default {
        name: "ErrorMain"
    }
</script>

<style scoped>
    .error-main {

    }
</style>